import { useFormik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import { frontApi } from "../../api";
import TextInput from "../../components/forms/TextInput";
import TextInputWithButton from "../../components/forms/TextInputWithButton";
import StaticLayout from "../../layouts/StaticLayout";
import { Label } from "recharts";
import { useSearchParams } from 'react-router-dom';
import { XyzTransition, XyzTransitionGroup } from "@animxyz/react";

const ConnectPC = () => {

  const [searchParams, setSearchParams] = useSearchParams();
  const language = searchParams.get('hl') || "English"

  var onPC = "On Your PC"
  var pcStep1 = "1. Download Fitforce2 into your PC using Microsoft Store or Steam (Coming soon)"
  var pcStep2 = "2. Open Fitforce2 on your PC."
  var pcStep3 = "3. You'll see a QR code on the homepage, which is used to connect with the mobile app."

  var ocPhone = "On Your Smartphone"
  var phoneStep1 = "1. Download Fitforce2 from the App Store or Google Play."
  var phoneStep2 = "2. Open the Fitforce2 app and sign up, or log in if you already have an account."
  var phoneStep3 = "3. Tap the Connect button on the homepage."
  var phoneStep4 = "4. Scan the QR code displayed on your PC screen."
  var phoneStep5 = "5. Start any game and enjoy the big screen experience!"

  if(language == "Thai")
  {
   onPC = "ในคอมพิวเตอร์"
   pcStep1 = "1. ดาวน์โหลด Fitforce2 ลงคอม จาก Microsoft Store หรือ Steam (เร็วๆนี้)"
   pcStep2 = "2. เปิดเกม Fitforce2 ในคอม"
   pcStep3 = "3. คุณจะเจอกับ คิวอาร์โค้ด ในหน้าแรก ซึ่งใช้เพื่อเชื่อมต่อเข้ากับแอพในมือถือ"
   ocPhone = "ในมือถือ"
   phoneStep1 = "1. ดาวน์โหลด Fitforce2 จาก แอปสโตร์ หรือ กูเกิลเพลย์"
   phoneStep2 = "2. เปิดแอพ Fitforce2 แล้ว สร้างบัญชีผู้ใช้ หรือ เข้าสู่ระบบ หากคุณมีบัญชีผู้ใช้อยู่แล้ว"
   phoneStep3 = "3. กดปุ่ม เชื่อมต่อ จากหน้าหลักของแอพ"
   phoneStep4 = "4. สแกน คิวอาร์โค้ด ที่แสดงอยู่บนจออมพิวเตอร์ของคุณ"
   phoneStep5 = "5. เริ่มเกม และ สนุกกับประสบการณ์บนจอใหญ่ๆ ได้เลย!"
  }

  return (
    <StaticLayout title={onPC}>
      <div id="pc" className="p-8 bg-white bg-opacity-85 rounded-xl">
          <div className="flex flex-col space-y-3">
            <p className="text-gray-700">{pcStep1}</p>
            <div class="flex flex-row">
                <a
                href="https://apps.microsoft.com/detail/9P509L7TRQ9M"
                target="_blank"
                className="cursor-pointer text-center w-40"
                rel="noreferrer">
                    <img src={require("../../img/Fitforce2/mceclip0-6360cfc4ee470.png")} class="w-full" />
                </a>
                <a
                href="https://store.steampowered.com/app/3932290/Fitforce2/"
                target="_blank"
                className="cursor-pointer text-center w-40"
                rel="noreferrer">
                    <img src={require("../../img/Fitforce2/steambadge.png")} class="w-full" />
                </a>
            </div>
            <p className="text-gray-700">{pcStep2}</p>
            <p className="text-gray-700">{pcStep3}</p>
        </div>
      </div>
        <XyzTransition appearVisible xyz="fade small out-down out-rotate-right">
            <p className="text-white text-xl mb-4 mt-8 lg:mt-16 lg:text-3xl textshadow">{ocPhone}</p>
        </XyzTransition>
      <div id="phone" className="p-8 bg-white bg-opacity-85 rounded-xl">
          <div className="flex flex-col space-y-3">
            <p className="text-gray-700">{phoneStep1}</p>
            <div class="flex flex-row">
                <a
                href="https://apps.apple.com/th/app/fitforce2/id1607830236"
                target="_blank"
                className="cursor-pointer text-center w-40"
                rel="noreferrer">
                    <img src={require("../../img/Fitforce2/getAppstore.png")} class="w-full" />
                </a>
                <a
                href="https://play.google.com/store/apps/details?id=com.RunnexTech.Fitforce2"
                target="_blank"
                className="cursor-pointer text-center w-40"
                rel="noreferrer">
                    <img src={require("../../img/Fitforce2/getGooglePlay.png")} class="w-full" />
                </a>
            </div>
            <p className="text-gray-700">{phoneStep2}</p>
            <p className="text-gray-700">{phoneStep3}</p>
            <p className="text-gray-700">{phoneStep4}</p>
            <p className="text-gray-700">{phoneStep5}</p>
        </div>
      </div>
      <br></br>
    </StaticLayout>
  );
};

export default ConnectPC;
